@if (showField$ | async) {
  <mat-form-field [floatLabel]="field.floatLabel || 'auto'">
    <mat-label>{{ field.label | translate }}</mat-label>
    <mtx-select
      [required]="!!field.validators?.required"
      [multiple]="true"
      [placeholder]="field.placeholder | translate"
      [items]="field.options"
      bindValue="value"
      [formControl]="$any(field.control)">
    </mtx-select>
    @if (hasDanger()) {
      <mat-hint [ngStyle]="{'color': 'red'}" align="start">{{errorText()}}</mat-hint>
    }
    @if (field.help && !hasDanger()) {
      <mat-hint align="start">{{field.help | translate}}</mat-hint>
    }
  </mat-form-field>
}
